import { createContext, useContext } from 'react';

const AuthContext = createContext(null);
function useAuthContext() {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuthContext must be used within AuthProvider');
    }
    return context;
}

export { AuthContext, useAuthContext };
//# sourceMappingURL=AuthContext.js.map
